// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootreducer';  // Make sure to adjust the path to match your folder structure

export const store = configureStore({
  reducer: rootReducer,  // Use the combined rootReducer here
  devTools: true, 
});
